import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
} from '@angular/core';

import { FractionColours } from './model/fl-winning.model';
@Component({
    selector: 'fraction-bar-winning',
    host: { class: 'fraction-bar' },
    templateUrl: './fraction-bar-wp.component.html',
})
export class FractionBarWinningComponent implements OnInit {
    @Input() winningNumber: number;
    @Input() losingNumber: number;
    @Input() neutralNumber: number;
    @Input() divisor: number;
    @Input() winningLabel: any;
    @Input() losingLabel: any;
    @Input() neutralLabel: any;
    @Input() maxWinning: number;
    @Input() maxLosing: number;
    @Input() maxNeutral: number;
    @Input() winningClass: string;
    @Input() neutralClass: string;
    @Input() losingClass: string;
    @Input() styles: FractionColours = {};
    @Input() barWidth = '';
    @Input() showHoverTooltip = false;

    @Output() public click: EventEmitter<any>;

    winningwidth: string;
    losingwidth: string;
    neutralwidth: string;

    maxWinningwidth: string;
    maxlosingwidth: string;
    maxneutralwidth: string;

    hoverdata: any;
    showHoverContainer = false;

    mouseLeft: number;

    constructor(public elRef: ElementRef) {
        this.click = new EventEmitter<any>();
    }

    ngOnChanges(args): void {
        if (
            Boolean(args) &&
            (Boolean(
                Object.prototype.hasOwnProperty.call(args, 'winningNumber'),
            ) ||
                Boolean(
                    Object.prototype.hasOwnProperty.call(args, 'denominator'),
                ))
        ) {
            this.recalculate();
        }
    }

    ngOnInit(): void {
        if (this.winningNumber != null && this.losingNumber != null) {
            this.recalculate();
        }
    }

    @HostListener('click', ['$event'])
    triggerClick(event): void {
        if (event !== undefined) {
            this.click.emit();
        }
    }

    recalculate(): void {
        this.setLeaderDimensions();
    }

    setSubordinateDimensions(): void {
        const winningwidth = (this.winningNumber / this.maxWinning) * 100;
        const logingwidth = (this.losingNumber / this.maxLosing) * 100;
        const neutralwidth = (this.neutralNumber / this.maxNeutral) * 100;

        const maxWinningwidth = (this.maxWinning / this.divisor) * 100;
        const maxLosingwidth = (this.maxLosing / this.divisor) * 100;
        const maxNeutralwidth = (this.maxNeutral / this.divisor) * 100;

        this.maxlosingwidth =
            typeof maxLosingwidth === 'number' &&
            maxLosingwidth !== Infinity &&
            maxLosingwidth !== -Infinity
                ? `${maxLosingwidth.toString()}%`
                : '0%';
        this.maxWinningwidth =
            typeof maxWinningwidth === 'number' &&
            maxWinningwidth !== Infinity &&
            maxWinningwidth !== -Infinity
                ? `${maxWinningwidth.toString()}%`
                : '0%';

        this.maxneutralwidth =
            typeof maxNeutralwidth === 'number' &&
            maxNeutralwidth !== Infinity &&
            maxNeutralwidth !== -Infinity
                ? `${maxNeutralwidth.toString()}%`
                : '0%';

        this.winningwidth =
            typeof winningwidth === 'number' &&
            winningwidth !== Infinity &&
            winningwidth !== -Infinity
                ? `${winningwidth.toString()}%`
                : '0%';

        this.neutralwidth =
            typeof neutralwidth === 'number' &&
            neutralwidth !== Infinity &&
            neutralwidth !== -Infinity
                ? `${neutralwidth.toString()}%`
                : '0%';

        this.losingwidth =
            typeof logingwidth === 'number' &&
            logingwidth !== Infinity &&
            logingwidth !== -Infinity
                ? `${logingwidth.toString()}%`
                : '0%';
    }

    setLeaderDimensions(): void {
        const win = (this.winningNumber / this.divisor) * 100;
        const losing = (this.losingNumber / this.divisor) * 100;
        const neutral = (this.neutralNumber / this.divisor) * 100;

        this.maxWinningwidth =
            typeof win === 'number' && win !== Infinity && win !== -Infinity
                ? `${win.toString()}%`
                : '0%';
        this.maxlosingwidth =
            typeof losing === 'number' &&
            losing !== Infinity &&
            losing !== -Infinity
                ? `${losing.toString()}%`
                : '0%';
        this.maxneutralwidth =
            typeof neutral === 'number' &&
            neutral !== Infinity &&
            neutral !== -Infinity
                ? `${neutral.toString()}%`
                : '0%';
        this.winningwidth = '100%';
        this.losingwidth = '100%';
        this.neutralwidth = '100%';
    }
}
